// Custom wuchale loader (selected via `loader: "custom"` in wuchale.config.js).
// Forked from @wuchale/jsx/src/loaders/react.bundle.js to fix initial-paint
// rendering: components that mount after `setLocale()` was already called miss
// the broadcast because the upstream loader hardcodes `useState(locales[0])`.
// We initialize state from the module-level `locale` so first paint matches the
// active locale, and re-sync on subscribe to cover the pre-subscription window.
import { useEffect, useMemo, useState } from "react";
import toRuntime from "wuchale/runtime";
import { locales } from "./data.js";

let locale = locales[0];

const callbacks = new Set([
	(/** @type {import('./data.js').Locale} */ loc) => {
		locale = loc;
	},
]);

/**
 * @param {import('./data.js').Locale} newLocale
 */
export function setLocale(newLocale) {
	for (const callback of callbacks) {
		callback(newLocale);
	}
}

export const getRuntimeRx = (
	/** @type {{[locale: string]: import('wuchale/runtime').CatalogModule }} */ catalogs,
) => {
	const [currentLocale, setCurrentLocale] = useState(() => locale);
	useEffect(() => {
		const cb = (/** @type {string} */ loc) => setCurrentLocale(loc);
		callbacks.add(cb);
		// Sync immediately in case `setLocale()` fired before this subscribe.
		setCurrentLocale(locale);
		return () => callbacks.delete(cb);
	}, [catalogs]);
	return useMemo(
		() => toRuntime(catalogs[currentLocale], currentLocale),
		[currentLocale, catalogs],
	);
};

// Non-reactive: reads module-level locale at call time.
export const getRuntime = (
	/** @type {{[locale: string]: import('wuchale/runtime').CatalogModule }} */ catalogs,
) => toRuntime(catalogs[locale], locale);
